import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" data-testid="login-page">
      <div className="hidden lg:flex lg:w-1/2 bg-[#0D0E10] text-white flex-col justify-between p-12">
        <div className="flex items-center">
          <img src="/reshine-logo.png" alt="Reshine India" className="h-10 w-auto" data-testid="login-logo-desktop" />
        </div>
        <div>
          <h1 className="font-display text-4xl xl:text-5xl font-semibold leading-tight tracking-tight">
            Every treasured piece,<br />
            <span className="gold-text">restored to brilliance.</span>
          </h1>
          <p className="mt-6 text-slate-400 max-w-md text-base leading-relaxed">
            The operations platform for metal restoration & refinishing — job registration, photo custody, status tracking and customer history in one place.
          </p>
        </div>
        <p className="text-xs text-slate-500">Gold · Silver · Brass · Copper · PVD · Antique Finishes</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center justify-center mb-8">
            <img src="/reshine-logo.png" alt="Reshine India" className="h-16 w-auto" data-testid="login-logo-mobile" />
          </div>
          <h2 className="font-sans text-2xl sm:text-3xl font-bold tracking-tight">Staff Sign In</h2>
          <p className="mt-2 text-sm text-muted-foreground">Sign in with your authorized Google account to access the workshop dashboard.</p>
          {error && (
            <div className="mt-4 flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 dark:bg-red-950/40 dark:border-red-900 p-3 text-sm text-red-700 dark:text-red-300" data-testid="login-error">
              <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}
          <Button
            data-testid="google-signin-button"
            onClick={handleLogin}
            className="mt-8 w-full h-12 text-base font-semibold"
          >
            <svg className="mr-2 h-5 w-5" viewBox="0 0 24 24"><path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" opacity=".7"/><path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" opacity=".5"/><path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" opacity=".9"/></svg>
            Continue with Google
          </Button>
          <p className="mt-4 text-xs text-muted-foreground text-center">Access is restricted to accounts authorized by the Reshine India admin.</p>
        </div>
      </div>
    </div>
  );
}
